import { render, staticRenderFns } from "./StorageInfo.vue?vue&type=template&id=4271639f&"
import script from "./StorageInfo.vue?vue&type=script&lang=js&"
export * from "./StorageInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports